<template>
  <div class="aboutwe_w site_min_w bc_fff">
    <div class="d_flex site_content site_min_h">
      <div class="side_menu_w bc_fff">
        <div v-if="cmsNode">
          <div class="directory_i">
            <img :src="cmsNode.icon" alt="" />
            <span class="span_1 fz16 c_fff">{{ cmsNode.name }} </span>
          </div>

          <router-link
            v-for="item in cmsNode.children"
            :key="item.id"
            :to="`${item.nodeModel.route}/${item.id}`"
            custom
          >
            <div
              class="menu_i c333 fz16"
              :class="Number(cmsNodeChild.id) === item.id ? 'c_0983CC' : ''"
            >
              <span>></span>
              <span class="span_2">{{ item.name }}</span>
            </div>
          </router-link>
        </div>
      </div>

      <div ref="mainRef" class="aboutwe_c_w d_flex flex_direction_col">
        <div
          v-if="cmsNode"
          class="head fz12 c_1A1A1A d_flex justify_content_sb"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>{{ cmsNode.name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div v-if="infoData" class="div_1">
          <div class="div_2 fz20 c_1A1A1A">{{ infoData.title }}</div>
          <div class="div_3" v-html="infoData.content" />
        </div>

        <div v-else class="div_4 x_y_center">
          <img src="@/assets/images/empty_icon.png" alt="" />
          <span class="span_1">暂无数据</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cms_article_first } from "@/api/portal";
import Cookies from "js-cookie";
import { mapGetters, mapActions } from "vuex";
import bus from "@/utils/bus";

export default {
  data() {
    return {
      infoData: null,
      cmsNode: null, // 栏目node
      cmsNodeChild: null,
    };
  },
  metaInfo() {
    return {
      title: `${this.cmsNode?.name ? this.cmsNode.name + " - " : ""} ${
        this.cmsNodeChild?.name ? this.cmsNodeChild.name + " - " : ""
      }${this.siteInfo?.name}`,
      meta: [
        {
          name: "keywords",
          content: `${this.cmsNode?.name ? this.cmsNode.name + "," : ""}${
            this.cmsNodeChild?.name ? this.cmsNodeChild.name + "," : ""
          }${this.infoData?.title ? this.infoData.title : ""}`,
        },
        {
          name: "description",
          content: `${this.infoData?.summary ? this.infoData.summary : ""}`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["siteInfo", "cmsProblemNode"]),
  },
  watch: {
    $route() {
      if(Object.keys(this.siteInfo).length){
        this.findPid(this.siteInfo.nodes); // 常见问题节点不在siteInfo返回，只能单独去调接口获取
        this.getInfo();
      }
    },
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.findPid(n.nodes); // 常见问题节点不在siteInfo返回，只能单独去调接口获取
          this.getInfo();
        }
      },
      immediate:true,
      deep:true,
    },
  },
  async created() {
    // 注意：常见问题和关于我们目前统一使用 public_0983cc/aboutwe/index.vue（后台模型为/aboutwe）
  },
  mounted() {},
  methods: {
    // 查询父菜单id
    findPid(nodes, parent) {
      if (nodes && nodes.length) {
        for (const i in nodes) {
          if (nodes[i].id === this.$route.params.id - 0) {
            this.cmsNode = parent || nodes[i];
            this.cmsNodeChild = nodes[i];
            return;
          }
          if (nodes[i].children && nodes[i].children.length) {
            this.findPid(nodes[i].children, nodes[i]);
          }
        }
      }
    },
    // 获取关于我们数据 api
    async getInfo() {
      const { data } = await cms_article_first({
        code: this.cmsNodeChild.code,
      });
      this.infoData = data;
    },
  },
};
</script>

<style lang='scss' scoped>
.aboutwe_w {
  padding: 35px 0;
  .side_menu_w {
    width: 216px;
    height: 100%;
    border: 1px solid #dbdbdb;
    margin: 0 10px 0 0;
    .directory_i {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 20px;
      background-color: #0983cc;
    }
    .menu_i {
      display: flex;
      align-items: flex-start;
      padding: 17px 20px;
      cursor: pointer;
      border-bottom: 1px solid #e6e6e6;
    }
    a {
      &:last-child {
        .menu_i {
          border: 0;
        }
      }
    }
  }
  .aboutwe_c_w {
    position: relative;
    flex: 1;
    border: 1px solid #e6e6e6;
    overflow: auto;
    min-height: 480px;
    &::-webkit-scrollbar {
      display: none;
    }
    & {
      scrollbar-width: none; //火狐
    }
  }
  .head {
    width: 100%;
    padding: 19px 20px;
    background: #e6e6e6;
  }
  .div_1 {
    height: 100%;
    padding: 0 0 30px 0;
  }
  .div_2 {
    display: inline-block;
    padding: 20px 0 14px 0;
    margin: 0 20px;
    border-bottom: 4px solid #0983cc;
  }
  .div_3 {
    padding: 15px 22px;
    border-top: 1px solid #e6e6e6;

    ::v-deep img {
      cursor: initial;
    }
  }
  .div_4 {
    height: 100%;
  }
  .span_1 {
    margin: 0 0 0 10px;
  }
  .span_2 {
    margin: 0 0 0 20px;
  }
}
</style>
